import {
    LOADING_TOGGLE_ACTION,  // Alterna estado de carregamento (loading)
    LOGIN_CONFIRMED_ACTION, // Confirma login bem-sucedido
    LOGIN_FAILED_ACTION,    // Indica falha no login
    LOGOUT_ACTION,          // Realiza logout do usuário
} from '../actions/AuthActions';

// Estado inicial do reducer
const initialState = {
    auth: {
        email: '',       // Email do usuário autenticado
        token: '',       // Token de autenticação
        localId: '',     // ID do usuário
        expiresIn: '',   // Tempo de expiração do token
        refreshToken: '',// Token de renovação
    },
    errorMessage: '',    // Mensagem de erro (se houver)
    successMessage: '',  // Mensagem de sucesso (se houver)
    showLoading: false,  // Indica se a aplicação está carregando algo
};

// Função reducer que gerencia o estado da autenticação
export function AuthReducer(state = initialState, action) {

    // Quando o login for bem-sucedido
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,   // Atualiza os dados de autenticação
            errorMessage: '',
            successMessage: 'Login Successfully Completed', // Exibe mensagem de sucesso
            showLoading: false,
        };
    }

    // Quando o usuário fizer logout
    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {                // Reseta os dados de autenticação
                email: '',
                token: '',
                localId: '',
                expiresIn: '',
                refreshToken: '',
            },
        };
    }

    // Quando o login ou cadastro falharem
    if (
        action.type === LOGIN_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload, // Armazena a mensagem de erro
            successMessage: '',
            showLoading: false,
        };
    }

    // Quando o estado de carregamento for alterado
    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload, // Atualiza o estado de carregamento
        };
    }

    // Se nenhuma ação correspondente for encontrada, retorna o estado atual
    return state;
}
